<script setup>
defineEmits(["close"]);
</script>

<template>
	<div class="popup" @click.stop="$emit('close')">
		<slot/>
		<Teleport to="body">
			<div class="ui-backdrop" @mousedown.left.self="$emit('close')"></div>
		</Teleport>
	</div>
</template>
